// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.overview-chart[data-v-1b465b49] {\n  padding: 0;\n}\n.badge[data-v-1b465b49] {\n  margin-right: 0.4rem;\n}\n", ""]);
// Exports
module.exports = exports;
